import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { offHoursPatchFixedCacheKey } from "../../thunks/off-hours/toggleOffHoursStatusThunk";
import { RootState } from "@/store/store";

export const offHoursUpdateLoadingSelector = (state: RootState): boolean => {
  return cloudChiprApi.endpoints.patchUsersMeOffHoursSchedulesByScheduleId.select(
    offHoursPatchFixedCacheKey,
  )(state).isLoading;
};
